module.exports = __webpack_public_path__ + "static/media/3 04 Tulleord Modil er feil-norming.8df8a5c4.mp3";